/* eslint-disable no-unused-vars */
/* eslint-disable no-shadow */

export enum TokenState {
  EMPTY = "Empty",
  INVALID = "Invalid",
  VALID = "Valid",
}
